import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import "../../../assets/scss/plugins/_slick.scss"
import "./blockMeaSlider.scss"
import Heading from "../heading"
import HTMLReactParser from "html-react-parser";
import Slider from "react-slick"
import { graphql } from "gatsby"
import Media from "../media"
import StyledButton from "../styledButton"

const BlkMeaSlider = ({ content }) => {

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  
  return (
    <section className="blk-mea-slider">
      <Container>
        <Row>
          <Col md={5}>
            <Heading
              caption={content.block_slider_caption}
              title={content.block_slider_title}
              description={HTMLReactParser(content.block_slider_description.processed)}
            />
          </Col>
          <Col md={7}>
            <Slider {...settings}>
              {content.relationships.block_slider_items.map((item, index) => (
              <div key={index}>
                {item.relationships.slider_item_media && <Media media={item.relationships.slider_item_media} />}
                <div className="slider-text">
                  <Heading title={item.slider_item_title} heading={4} description={HTMLReactParser(item.slider_item_description.processed)} />
                  {item.slider_item_link && <StyledButton path={item.slider_item_link.url} title={item.slider_item_link.title} type={"link"} />}
                </div>
              </div>
              ))}
            </Slider>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export const query = graphql`
  fragment meaSlider on paragraph__block_slider {
    block_slider_caption
    block_slider_description {
      processed
    }
    block_slider_link {
      title
      url
    }
    block_slider_title
    relationships {
      block_slider_items {
        slider_item_title
        slider_item_description {
          format
          processed
        }
        slider_item_link {
          title
          url
        }
        relationships {
          slider_item_media {
            field_image {
              alt
            }
            relationships {
              ...getImage
            }
          }
        }
      }
    }
  }
`

export default BlkMeaSlider
